// @flow
import {
  loadModularUI,
  removeModelByKey,
} from "../_modularui/ModularUIActions";
import {
  allKeysByHref,
  getApplication,
} from "../_modularui/ModularUISelectors";
import { ApplicationModel, Href } from "../../models";
import { getLocale } from "../selectors/i18n";

import type { ThunkAction, NoAction } from "../types";

/**
 */
export const reloadApplication =
  (): ThunkAction<Promise<ApplicationModel>> =>
  async (dispatch, getState, { subscribe }) => {
    const state = getState();

    let applicationHref = new Href("/", "Application");
    const application = getApplication(state);
    if (application) {
      applicationHref.contextPath = application.contextPath;
      applicationHref.origin = application.origin;
    }

    const modelKey = `application(/)(${getLocale(state)})`;
    const allKeys = allKeysByHref(state, applicationHref);

    for (const key of allKeys) {
      if (key !== modelKey) {
        // only remove applications we're not reloading (e.g. different locale)
        dispatch(removeModelByKey(key));
      }
    }

    dispatch(
      loadModularUI(modelKey, applicationHref, {
        targetModel: ApplicationModel,
      }),
    );

    return new Promise((resolve, reject) => {
      const unsubscribe = subscribe(() => {
        const entry = getState().modularui?.[modelKey];

        if (entry?.status === "FINISHED") {
          unsubscribe();
          if (entry.model instanceof ApplicationModel) {
            resolve(entry.model);
          } else {
            reject(new Error("Loaded model was not an ApplicationModel"));
          }
        } else if (entry?.status === "ERROR") {
          unsubscribe();
          reject(new Error("Application reload failed."));
        }
      });

      // Safety timeout so the login screen doesn't hang forever if the API fails silently
      setTimeout(() => {
        unsubscribe();
        reject(new Error("Timeout waiting for application reload."));
      }, 15000);
    });
  };

/**
 */
export const noAction = (): NoAction => ({
  type: "NO_ACTION",
});
